import { Component, Input } from "@angular/core";
import { TabsComponent } from "./tabs.component";

@Component({
    selector: 'tab',
    template: `
    <div [hidden]="!active">
      <ng-content></ng-content>
    </div>
  `,
    standalone: false
})

export class TabComponent {

  @Input() title: string;

  active: boolean = false;

  constructor(tabs: TabsComponent) {
    tabs.addTab(this);
  }

}